import type {
  T_CountryItem,
  T_FiltrationLogicProps,
} from '@fe/types/modules/localization/common/client/types';
import COUNTRIES from '../constants/country-names-in-all-languages';
import { FILTERED_COUNTRIES } from '../constants/phone';

export const useFiltrationLogic = ({
  setSelectedFlagCode,
  setSelectedCountryCode,
  setFilteredCodes,
  setSelectedCountry,
}: T_FiltrationLogicProps) => {
  const onSearchValueChange = (search: string) => {
    const query = search.toLowerCase();

    const arabicMatches = COUNTRIES.filter((c) => c.ar?.toLowerCase().includes(query)).map((c) =>
      c.en?.toLowerCase(),
    );

    const enriched = FILTERED_COUNTRIES();

    const filtered = enriched.filter((c) => {
      const nameMatch = c.name.toLowerCase().includes(query);
      const dialMatch = c.dialCode?.includes(query);
      const arabicMatch = arabicMatches.includes(c.name.toLowerCase());

      return nameMatch || dialMatch || arabicMatch;
    });

    setFilteredCodes(filtered);
  };

  const onCountrySelect = (country: T_CountryItem) => {
    setSelectedCountry(country);
    setSelectedFlagCode(country?.isoCode?.toLowerCase());
    setSelectedCountryCode(country?.dialCode);
  };

  return {
    onCountrySelect,
    onSearchValueChange,
  };
};
